import { render, staticRenderFns } from "./Filho.vue?vue&type=template&id=eff04eb4&"
import script from "./Filho.vue?vue&type=script&lang=js&"
export * from "./Filho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports